/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
    FactorMethodToJSONTyped,
} from './FactorMethod';

/**
 * 
 * @export
 * @interface PasswordMethodOptions
 */
export interface PasswordMethodOptions {
    /**
     * 
     * @type {FactorMethod}
     * @memberof PasswordMethodOptions
     */
    method: FactorMethod;
}



/**
 * Check if a given object implements the PasswordMethodOptions interface.
 */
export function instanceOfPasswordMethodOptions(value: object): value is PasswordMethodOptions {
    if (!('method' in value) || value['method'] === undefined) return false;
    return true;
}

export function PasswordMethodOptionsFromJSON(json: any): PasswordMethodOptions {
    return PasswordMethodOptionsFromJSONTyped(json, false);
}

export function PasswordMethodOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordMethodOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'method': FactorMethodFromJSON(json['method']),
    };
}

export function PasswordMethodOptionsToJSON(json: any): PasswordMethodOptions {
    return PasswordMethodOptionsToJSONTyped(json, false);
}

export function PasswordMethodOptionsToJSONTyped(value?: PasswordMethodOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'method': FactorMethodToJSON(value['method']),
    };
}

